import Vue from 'vue'
import { MutationTree } from 'vuex'

const mutations: MutationTree<any> = {
  /**
   * 是否加入WPS+企业
   * @param state
   * @param payload 状态
   */
  SET_IS_JOIN_ENTERPRISE_PLUS (state, payload) {
    Vue.set(state, 'isJoinEnterprisePlus', payload)
  },
  SET_ENTERPRISE_LIST (state, payload) {
    Vue.set(state, 'enterpriseList', payload)
  },
  SET_PRI_CONF (state, payload) {
    Vue.set(state, 'priConfig', payload)
  }
}

export default mutations
